<template>
	<div class="navbar-btns-inner">
		<div class="navbar-toggler navbar-btn collapsed" data-toggle="collapse" data-target="#menu"><i class="mx-auto mb-1" data-feather="menu"></i>Меню</div>
		<a class="navbar-btn bg-0 my-3 border-left-0 navbar-collapse-hidden" href="/Home/Comparison">
			<span class="d-block position-relative">
				<span class="navbar-btn-badge bg-secondary border">{{compareItemCount}}</span>
				<i class="mx-auto mb-1" data-feather="repeat"></i>Сравнение
			</span>
		</a>

		<a class="navbar-btn" href="#offcanvas-search" data-toggle="offcanvas"
		   v-if="!hideSearchButton">
			<i class="mx-auto mb-1" data-feather="search"></i>Поиск
		</a>

		<a class="navbar-btn" href="#offcanvas-profile" data-toggle="offcanvas"
		   v-bind:class="{ 'bg-0': hideSearchButton, 'my-3': hideSearchButton }">
			<span v-if="userLogged">
				<i class="mx-auto mb-1 fa fa-user-o"></i><br />
				<span class="d-none d-sm-inline">Мой профиль</span>
				<span class="d-inline d-sm-none">Я</span>
			</span>
			<span v-else>
				<i class="mx-auto mb-1 fa fa-sign-in"></i><br />Вход
			</span>
		</a>

		<a class="navbar-btn" href="#offcanvas-cart" data-toggle="offcanvas"
		   v-bind:class="{ 'bg-0': hideSearchButton, 'my-3': hideSearchButton }">
			<span class="d-block position-relative">
				<span class="navbar-btn-badge bg-primary text-light">{{itemCount}}</span>
				<i class="mx-auto mb-1" data-feather="shopping-cart"></i>₽ {{totalSum}}
			</span>
		</a>
	</div>
</template>
<script>
	import { actions, getters, namespace } from "User/store/store";
	import { getters as cartGetters, namespace as cartNamespace } from "Cart/store/store";
	import { namespace as compareNamespace, actions as compareActions, getters as compareGetters } from "Compare/store/store";
	import { mapGetters, mapActions } from "vuex";

	export default {
		name: "login-button",
		props: {
			hideSearchButton: Boolean
		},
		computed: {
			...mapGetters(namespace, {
				userName: getters.userName.name,
				userLogged: getters.userLogged.name
			}),
			...mapGetters(cartNamespace, {
				totalSum: cartGetters.totalSum.name,
				itemCount: cartGetters.itemCount.name
			}),
			...mapGetters(compareNamespace, {
				compareItemCount: compareGetters.itemCount.name
			})
		},
		created() {
			this.getUserInfo();
			this.getProducts();
		},
		methods: {
			...mapActions(namespace, {
				logInUser: actions.logInUser.name,
				logOut: actions.logOutUser.name,
				getUserInfo: actions.getUserInfo.name
			}),
			...mapActions(compareNamespace,
				{
					getProducts: compareActions.getProducts.name
				})
		}
	}
</script>
